function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "b51wzqghtj",
  cx: "-4.847%",
  cy: "-.239%",
  r: "401.337%",
  fx: "-4.847%",
  fy: "-.239%",
  gradientTransform: "matrix(.26722 0 0 1 -.036 0)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#3E2723",
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#3E2723",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "nd5shhfl5m",
  cx: "-.122%",
  cy: ".104%",
  r: "136.314%",
  fx: "-.122%",
  fy: ".104%",
  gradientTransform: "matrix(1 0 0 .84752 0 0)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#3E2723",
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#3E2723",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "5hjmbps99n",
  cx: "10.227%",
  cy: "-12.225%",
  r: "226.352%",
  fx: "10.227%",
  fy: "-12.225%",
  gradientTransform: "matrix(1 0 0 .49642 0 -.062)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#263238",
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#263238",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ih6xvghvoc",
  x1: "4.549%",
  x2: "36.95%",
  y1: "55.356%",
  y2: "42.739%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#A52714",
  stopOpacity: 0.6
}), /*#__PURE__*/React.createElement("stop", {
  offset: "66%",
  stopColor: "#A52714",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "u8cjwsvb4d",
  x1: "70.039%",
  x2: "41.91%",
  y1: "87.776%",
  y2: "66.337%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#055524",
  stopOpacity: 0.4
}), /*#__PURE__*/React.createElement("stop", {
  offset: "33%",
  stopColor: "#055524",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "w53lua66yg",
  x1: "41.002%",
  x2: "49.277%",
  y1: "-4.844%",
  y2: "45.391%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#EA6100",
  stopOpacity: 0.3
}), /*#__PURE__*/React.createElement("stop", {
  offset: "66%",
  stopColor: "#EA6100",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  id: "qni1wtslhe",
  d: "M0 36.255L19.039 36.255 27.875 27.418 27.875 20.8 12.125 20.8 0 0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "hz5ma4lq6h",
  d: "M0.961 0L8.836 13.636 0 29.091 20.961 29.091 20.961 0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "ddkrx7ebwk",
  d: "M0 0L0 9.168 8.952 24.545 16.825 10.909 36.825 10.909 36.825 0z"
}), /*#__PURE__*/React.createElement("circle", {
  id: "btsmfcaxza",
  cx: 20,
  cy: 20,
  r: 20
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-167 -591) translate(48 336) translate(119 255)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "drsyx9cjjb",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#btsmfcaxza"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#drsyx9cjjb)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#DB4437",
  fillRule: "nonzero",
  d: "M3.175 0L3.175 24.545 12.13 24.545 20 10.909 40 10.909 40 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ih6xvghvoc)",
  fillRule: "nonzero",
  d: "M3.175 0L3.175 24.545 12.13 24.545 20 10.909 40 10.909 40 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3E2723",
  fillOpacity: 0.15,
  fillRule: "nonzero",
  d: "M12.341 24.455L3.291 8.932 3.159 9.159 12.145 24.568z"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#0F9D58",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 36.255L19.039 36.255 27.875 27.418 27.875 20.8 12.125 20.8 0 0z",
  transform: "translate(0 3.745)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#u8cjwsvb4d)",
  fillRule: "nonzero",
  d: "M0 40L19.039 40 27.875 31.164 27.875 24.545 12.125 24.545 0 3.745z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#263238",
  fillOpacity: 0.15,
  fillRule: "nonzero",
  d: "M27.682 24.841L27.493 24.732 18.766 39.993 19.027 39.993 27.686 24.848z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 3.745)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "163fkufbpf",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#qni1wtslhe"
})), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  mask: "url(#163fkufbpf)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#FFCD40",
  d: "M0.961 0L8.836 13.636 0 29.091 20.961 29.091 20.961 0z",
  transform: "translate(19.039 7.164)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#w53lua66yg)",
  d: "M0.961 0L8.836 13.636 0 29.091 20.961 29.091 20.961 0z",
  transform: "translate(19.039 7.164)"
})))), /*#__PURE__*/React.createElement("path", {
  fill: "#FFCD40",
  fillRule: "nonzero",
  d: "M20 10.909L27.875 24.545 19.039 40 40 40 40 10.909z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#w53lua66yg)",
  fillRule: "nonzero",
  d: "M20 10.909L27.875 24.545 19.039 40 40 40 40 10.909z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(19.039 10.91)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "zzjjt6pu7i",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#hz5ma4lq6h"
})), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  mask: "url(#zzjjt6pu7i)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#DB4437",
  d: "M0 0L0 24.545 8.955 24.545 16.825 10.909 36.825 10.909 36.825 0z",
  transform: "translate(-15.864 -10.91)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#ih6xvghvoc)",
  d: "M0 0L0 24.545 8.955 24.545 16.825 10.909 36.825 10.909 36.825 0z",
  transform: "translate(-15.864 -10.91)"
}))))), /*#__PURE__*/React.createElement("g", {
  mask: "url(#drsyx9cjjb)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "url(#b51wzqghtj)",
  fillRule: "nonzero",
  d: "M16.825 10.909L16.825 15.67 34.643 10.909z",
  transform: "translate(3.175)"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(3.175)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "c4wgopww4l",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#ddkrx7ebwk"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#c4wgopww4l)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#0F9D58",
  fillRule: "nonzero",
  d: "M0 36.255L19.039 36.255 27.875 27.418 27.875 20.8 12.125 20.8 0 0z",
  transform: "translate(-3.175 3.745)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#u8cjwsvb4d)",
  fillRule: "nonzero",
  d: "M0 36.255L19.039 36.255 27.875 27.418 27.875 20.8 12.125 20.8 0 0z",
  transform: "translate(-3.175 3.745)"
}))))))), /*#__PURE__*/React.createElement("path", {
  fill: "url(#nd5shhfl5m)",
  fillRule: "nonzero",
  d: "M3.175 9.193L16.186 22.202 12.127 24.545z",
  mask: "url(#drsyx9cjjb)"
}), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  mask: "url(#drsyx9cjjb)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#5hjmbps99n)",
  d: "M19.052 39.977L23.816 22.205 27.875 24.545z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 9.091,
  fill: "#F1F1F1"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 7.273,
  fill: "#4285F4"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3E2723",
  fillOpacity: 0.2,
  d: "M20 10.682c-5.023 0-9.09 4.068-9.09 9.09V20c0-5.023 4.067-9.09 9.09-9.09h20v-.228H20z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillOpacity: 0.1,
  d: "M27.864 24.545c-1.573 2.714-4.5 4.546-7.864 4.546s-6.295-1.832-7.864-4.546h-.009L0 3.745v.228l12.136 20.8c1.573 2.713 4.5 4.545 7.864 4.545s6.29-1.83 7.864-4.545h.011v-.228h-.014.003z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3E2723",
  d: "M20.227 10.91c-.038 0-.075.004-.113.006 4.968.061 8.977 4.102 8.977 9.084 0 4.982-4.01 9.023-8.977 9.084.038 0 .075.007.113.007 5.023 0 9.091-4.068 9.091-9.091s-4.068-9.09-9.09-9.09z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillOpacity: 0.2,
  d: "M27.955 24.84c.772-1.335 1.22-2.88 1.22-4.535 0-.933-.143-1.86-.425-2.748.216.777.34 1.59.34 2.438 0 1.655-.447 3.2-1.22 4.537l.005.009-8.836 15.454h.263l8.653-15.154z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillOpacity: 0.2,
  d: "M20 .227c11.007 0 19.936 8.893 20 19.887l.002-.114c0-11.045-8.954-20-20-20C8.957 0 0 8.955 0 20l.002.114C.064 9.12 8.993.227 20 .227z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3E2723",
  fillOpacity: 0.15,
  d: "M20 39.773c11.007 0 19.936-8.893 20-19.887l.002.114c0 11.045-8.954 20-20 20C8.957 40 0 31.045 0 20l.002-.114c.062 10.994 8.991 19.887 20 19.887H20z"
}))))));

var SvgIcChrome = function SvgIcChrome(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcChrome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-chrome.8c4a529e.svg";
export { ForwardRef as ReactComponent };